import { getTenantById } from 'tenants';
import { useLocale } from './use-locale';
import { useTenantId } from './use-tenant-id';

export function useLinkLocaleSetting(): string | false {
  const tenantId = useTenantId();
  const tenant = getTenantById(tenantId);
  const { currentLocale } = useLocale(tenantId);  
  return tenant.localization?.persistLocalePreference ? currentLocale : false;
}
